module.exports = __webpack_public_path__ + "static/media/people_security.bfcdae88.jpg";